module.exports = __webpack_public_path__ + "img/legume-lima-beans-190x100.ed0c4b8b.jpg";